var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.015 2H2l4.015 19.917c.44.035 1.49.053 2.166-.159.677-.21 1.55-.616 1.903-.792L6.015 2zM7.6 30l-.898-4.65c.3-.07.983-.22 1.32-.263.423-.053 1.11-.317 1.586-.528.38-.17.616-.213.686-.213l.159 1.796.528-1.954c.177-.054.656-.17 1.163-.213.508-.042 1.304-.193 1.638-.264L11.881 30H7.6zm7.45-10.513.66-2.54.66 2.54c.14.017.58.074 1.215.158.634.085 1.391.317 1.69.423l-2.535-8.559H14.679l-2.537 8.558c.3-.106 1.057-.338 1.69-.423.635-.084 1.075-.14 1.216-.158zM25.403 2h4.015l-4.016 19.917c-.44.035-1.49.053-2.166-.159-.677-.21-1.55-.616-1.902-.792L25.404 2zm-1.585 28 .897-4.65c-.3-.07-.983-.22-1.32-.263-.423-.053-1.11-.317-1.586-.528-.38-.17-.615-.213-.685-.213l-.16 1.796-.527-1.954a6.402 6.402 0 0 0-1.163-.213c-.507-.042-1.303-.193-1.637-.264L19.54 30h4.279z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFis);
export default __webpack_public_path__ + "static/media/FIS.6000de2d63c909ac1a153346f6a4d4dd.svg";
export { ForwardRef as ReactComponent };